define('SageDotCom/Components/Content/Tooltip',["jquery"],
    function($) {

        function Tooltip(scope) {
            var toolTipElem = $('[data-toggle="tooltip"]', scope);

            // remove the html tags that can be caused by plain text
            var newTitle = toolTipElem.attr('title');
            newTitle = newTitle.replace(/(<([^>]+)>)/ig, "");

            toolTipElem.attr('title', newTitle).tooltip('fixTitle');  
        }

        Tooltip.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new Tooltip(args.scope);
        };

        return Tooltip;
    });

